import { sdkConnector } from './sdkConnector';
import { TemplateFields, updateTemplateFieldFromExternal } from './helpers';
import Store from './Store';

// Will be used to fetch products with ajax and store the secrets.
export let productsReq = {
  website_id: null,
  template_id: null,
  api_key: null,
};
// Fetched products will be stored here globally.
export let products = [];
export let null_product_active;
export let allTemplateValues;
export let isCibTemplate;
export let isLooksTemplate;
export let isBrandEnabled;

export let Keys = {
  gtmAddToCartKey: null,
  gtmGoToProductKey: null,
  mobileDeepLinkToggle: null,
  apiKey: null,
  websiteID: null,
};

let activeCategoryName = null;
const DEFAULT_CONTAINER_MARGIN = 50;

/**
 * Needs to adjust margin-top main container since header is position: fixed.
 * Get the header height and set as margin to leave no space between in mobile.
 * There need to be extra margin in wide screens above tablet.
 */
const setHeaderHeightAndMargin = () => {
  const headerHeight = $('.header').outerHeight();
  const templateType = $('.template_type').val();
  let marginBetweenHeaderAndContainer = headerHeight;
  // In the desktop, there should be extra default margin between elements.
  // We don't want any extra space between header and plugin in mobile.
  if ($(window).width() > helpers.Breakpoints.WIDE_TABLET) {
    marginBetweenHeaderAndContainer += DEFAULT_CONTAINER_MARGIN;
  }
  if (templateType != 'popi' || templateType != 'sad') {
    $('#container')[0].style.setProperty(
      'margin-top',
      marginBetweenHeaderAndContainer + 'px',
      'important',
    );
  }
};

/**
 * Hides active product element and action buttons. It is needed
 * when user select a parent carousel item or when active product is null.
 */
export const hideActiveProduct = () => {
  $('.active-product').addClass('passive');
  $('.go-product-btn, .add-cart-btn, .all-product-qr').removeClass('active');
};

$(async () => {
  helpers.addGtmScript();
  const isMobile = helpers.checkIsMobile();

  if (!window.shouldDisablePluginAspectRatio) {
    helpers.setPluginContainerAspectRatio({ bufferWidth: helpers.getPluginBufferSize(true) });
    helpers.observeWindowWidth({
      onResize: () => {
        helpers.setPluginContainerAspectRatio({ bufferWidth: helpers.getPluginBufferSize(true) });
      },
    });
  }
  helpers.observeContainerHeight();

  $('.try-btn').click(function () {
    const qrLogID = $('.qr_log_id').val();

    $.ajax({
      type: 'POST',
      url: '/engine/v0/qr_data_collect',
      dataType: 'json',
      data: {
        log_id: qrLogID,
        action_type: 'try_on',
      },
    });
    $('.qr-modal').hide();
  });

  // If header exists and fixed at the top, add an initial margin to prevent overlapping.
  // Margin will be added according to height of header.
  const isHeaderExist = Boolean($('.header'));
  if (isHeaderExist) {
    const secondLogoUrl = $('.second-logo-url').val();
    // val() gives a string, we need to check explicitly if it's true.
    if (secondLogoUrl !== 'false') {
      $('.header').addClass('second-header-logo');
      $('.header').append(`<img src="${secondLogoUrl}" alt="second logo" />`);
    }
    // We are listening the images to load, but they load only once.
    // Then browser cache the images, so function inside "load" doesn't invoke on refresh.
    // If image has height, that means it already is loaded and ready to use.
    const headerImage = $('.header img');
    if (headerImage.height()) {
      setHeaderHeightAndMargin();
    }

    // Wait for the images to load before retrieving their height.
    headerImage.on('load', function () {
      setHeaderHeightAndMargin();
    });
  }

  let activeColorID;
  const specifiedProducts = JSON.parse($('.specified_products').val());
  const specifiedQrParams = JSON.parse($('.specified_qr_params').val());
  const queryParams = JSON.parse($('.query-param').val());
  const templateID = $('.template_id_input').val();
  const hasArrow = $('.arrow_enable_input').val();
  const hasQr = $('.has_qr').val() == 'true';
  const combineCategoriesParams = JSON.parse($('.combine_categories_params').val());
  isBrandEnabled = $('.is_brand_enable').val() === 'true';
  Store.categories = JSON.parse($('.category_list').val());
  null_product_active = $('.null_product_active').val() == 'true';
  allTemplateValues = JSON.parse($('.template_values').val());
  isCibTemplate = $('.template_type').val() === 'cib';
  isLooksTemplate = $('.template_type').val() === 'looks';
  Keys.websiteID = $('.website_id_input').val();
  Keys.gtmAddToCartKey = $('.gtm_add_to_cart_key').val();
  Keys.gtmGoToProductKey = $('.gtm_go_to_product_key').val();
  Keys.mobileDeepLinkToggle = JSON.parse($('.mobile_deep_link_toggle').val());
  Keys.apiKey = $('.api_key_input').val();

  if (hasArrow == 'true') {
    $('.categories,.products').addClass('arrow-enable');
  }

  productsReq.template_id = templateID;
  productsReq.website_id = Keys.websiteID;
  productsReq.api_key = Keys.apiKey;

  if (hasQr) {
    helpers.handleSpecificParamsByQr({
      key: Object.keys(queryParams)[0],
      paramsData: specifiedQrParams,
      productsData: specifiedProducts,
    });
    // Main page shows up when user scroll the QR page on mobile, hide here.
    $('#container').addClass('hidden');
  }

  const hasSeriesOrProductQr = queryParams.seriesQr || queryParams.productQr;
  // Hide unnecessary collapse menu if there is any param given.
  if (!$.isEmptyObject(queryParams)) {
    $('.categories-container').hide();
    $('.choose-category-text').hide();
    $('.products-container').slideDown(300);

    // If it is single specified product, wrap it in array to use in pre-existing functions.
    // E.g., productQr -> {}, seriesQr -> [{}, {}].
    switch (true) {
      case Boolean(queryParams.productQr):
        products = [specifiedProducts];
        break;
      case Boolean(queryParams.seriesQr):
        products = specifiedProducts.series.products;
        break;
      // categoryQr passed in, its structure -> {category: .., products: [{}, {}]}.
      default:
        products = specifiedProducts.products;
    }

    helpers.assignCategoryProducts({
      container: '.products',
      categoryProducts: products,
    });
    owlConfigs.makeProductsCarousel();
    activeCategoryName = products[0] && products[0].categ_id[1].split('/')[1].trim();
    // Switch to Nail plugin if QR category is Nailpolish.
    if (activeCategoryName === 'Nailpolish') {
      helpers.setPlugin({ isNail: true });
    }

    if (hasSeriesOrProductQr) {
      // Do not show title menu on single product.
      if (queryParams.productQr || hasQr) {
        $('.brands-container').addClass('passive');
        $('.category-title').addClass('passive');
      }

      if (hasQr) {
        $('.products-container').addClass('passive');
        setTimeout(() => $('.product').click());
      }
    }
  } else {
    // Fetch all products only if specified products do not exist.
    await $.ajax({
      type: 'POST',
      url: '/engine/v0/products',
      dataType: 'json',
      data: productsReq,
      success: function (res) {
        products = res;
        Store.categories = helpers.getValidCategoryList(Store.categories, products);
      },
    });
  }

  if (!['flormar', 'unique', 'looks'].includes($('.template_type').val())) {
    helpers.makeBrandsOwl();

    if (!isBrandEnabled) {
      helpers.makeCategoriesOwl();
    }
  }

  helpers.updateProductButton({
    selector: '.add-cart-btn, .go-product-btn, .all-product-qr',
  });

  $('.purchase-btn').css({
    color: pulpo.allTemplateValues.buy_all_products_text_color,
    'background-color': pulpo.allTemplateValues.buy_all_products_button_color,
  });

  // This list might be updated by brands filtering below.
  let productList = products;
  const shouldHideCategorySection =
    Store.categories.length === 1 && allTemplateValues.is_product_category_hide;

  const hasProductQrLinkButton = allTemplateValues.logo_qr_active;
  let allProductBarcode = [];

  // If there is only one category and is product category hide is enable, hide it.
  if (shouldHideCategorySection) {
    $('.products-container').slideDown(300);
    const categoryName = Store.categories[0].name;
    helpers.setProductsContainer({
      productList: productList,
      categoryName: categoryName,
      combineCategoriesParams: combineCategoriesParams,
    });
    activeCategoryName = categoryName;
  }

  $('.brand').click(function () {
    if ($(this).hasClass('active')) {
      return;
    }
    $('.products-container').hide();
    $('.colors-container').slideUp(200);
    $('.active-product').addClass('passive');
    $('.brand').removeClass('active');
    $('.brand-title.brand-section, .category-title.brand-section').addClass('closed');
    $(this).addClass('active');
    helpers.destroyExistingOwl('.categories');
    helpers.destroyExistingOwl('.products');
    const selectedBrandName = $(this).data('name').trim();
    // Get products based on selected brand.
    const uniqueBrandProducts = [
      ...new Set(
        products.filter(
          (product) => product.categ_id[1] && product.categ_id[1].includes(selectedBrandName),
        ),
      ),
    ];
    // Get unique category list of products.
    const uniqueBrandCategories = uniqueBrandProducts.map((product) => product.categ_id[1]);
    const filteredCategoriesByBrand = helpers.filterCategoriesByBrand(
      Store.categories,
      uniqueBrandCategories,
    );
    productList = uniqueBrandProducts;
    const shouldHideCategorySection =
      filteredCategoriesByBrand.length === 1 && allTemplateValues.is_product_category_hide;
    // Hide category container if there is one category and if product category hide is enable.
    if (shouldHideCategorySection) {
      $('.categories-container').hide();
      $('.products-container').slideDown(0);
      setTimeout(() => helpers.openNextSection('.product-collapse'), 300);
      const categoryName = filteredCategoriesByBrand[0].name;
      helpers.setProductsContainer({
        productList: productList,
        categoryName: categoryName,
        combineCategoriesParams: combineCategoriesParams,
      });
      activeCategoryName = categoryName;

      if (categoryName == 'Nailpolish') {
        helpers.setPlugin({ isNail: true });
        return;
      }
      helpers.setPlugin({ isNail: false });
      return;
    }
    // Show category container if there is more than one category or if product category hide is disabled.
    helpers.assignCategories({
      container: '.categories',
      categoryList: filteredCategoriesByBrand,
    });
    helpers.makeCategoriesOwl();
    $('.categories-container').slideDown(300);
    setTimeout(() => helpers.openNextSection('.category-collapse'), 300);
    helpers.closeCurrentSectionInMobile('.brand-section');
    helpers.sendEventToMobileApps({
      key: helpers.TemplateEvents.BRAND_SELECTED,
      value: selectedBrandName,
    });
  });

  $('.categories').on('click', '.category', function () {
    if ($(this).hasClass('active')) {
      return;
    }
    if (null_product_active) {
      helpers.removeMakeup(activeCategoryName);
      helpers.removeProduct();
    }
    hideActiveProduct();
    $('.colors-container').slideUp(200);
    $('.products-container').slideDown(300);
    $('.category').removeClass('active');
    $(this).addClass('active');
    let categoryName = $(this).data('name').trim();
    window.parent.postMessage(
      {
        hitType: 'event',
        event: 'category_chosen',
        productCategory: categoryName,
      },
      '*',
    );
    helpers.sendEventToMobileApps({
      key: helpers.TemplateEvents.CATEGORY_SELECTED,
      value: categoryName,
    });

    if (categoryName == 'Nailpolish') {
      helpers.setPlugin({ isNail: true });
      makeupView.contentWindow.window.postMessage(
        JSON.stringify({
          removeProduct: activeCategoryName,
        }),
        '*',
      );
    } else {
      helpers.setPlugin({ isNail: false });
    }

    helpers.destroyExistingOwl('.products');
    helpers.setProductsContainer({
      productList: productList,
      categoryName: categoryName,
      combineCategoriesParams: combineCategoriesParams,
    });
    activeCategoryName = categoryName;
  });

  $('.products').on('click', '.product', function () {
    if ($(this).hasClass('active')) {
      return;
    }
    $('.category-title.color-section').removeClass('closed');
    $('.product').removeClass('active');
    $(this).addClass('active');
    $('.category-title.product-section').addClass('closed');
    activeColorID = $(this).data('id');
    const productName = $(this).find('.product-name').text().trim(),
      productCode = $(this).data('code'),
      productImage = $(this).find('.product-image').attr('src'),
      productColor = $(this).data('color-name'),
      productCategory = $(this).data('category'),
      hdriUrlForGlass = $(this).data('hdri');
    window.parent.postMessage(
      {
        hitType: 'event',
        event: 'group_chosen',
        productCategory: productCategory,
        productGroup: productName,
      },
      '*',
    );
    helpers.sendEventToMobileApps({
      key: helpers.TemplateEvents.PRODUCT_SELECTED,
      value: productName,
    });

    if (!null_product_active) {
      helpers.applySelectedProduct({
        productCategory,
        productCode,
        productColor,
        productName,
        productId: activeColorID,
        hdriUrlForGlass,
      });
      helpers.toggleProductButtons({
        activeColorID,
        goProductSelector: '.go-product-btn',
        addCartSelector: '.add-cart-btn',
        productQRSelector: '.all-product-qr',
      });
      $('.active-product-image').attr('src', productImage);
      $('.active-product-name').html(productColor);
      if (hasSeriesOrProductQr && hasQr) {
        $('.active-product-name').html(`${productName} - ${productColor}`);
      }
      helpers.hidePaletteProductName(productColor, '.active-product-name');
      $('.active-product').removeClass('passive');
    } else {
      hideActiveProduct();
      helpers.removeMakeup(activeCategoryName);
      helpers.removeProduct();
    }
    helpers.destroyExistingOwl('.colors');
    if (isCibTemplate || isLooksTemplate) {
      $('.colors').html('');
    }

    let filteredProducts = productList
      .filter((product) => product.name == productName)
      .sort((a, b) => a.color_code - b.color_code);

    helpers.assignProductColors({
      productList: filteredProducts,
      productName,
      productCategory,
      colorsContainer: '.colors',
    });

    $('.colors .color:first').addClass('active');
    // Toggles collapse menu in mobile to have more available space.
    if (isMobile && !queryParams.productQr) {
      $('.product-section').click();
      helpers.openNextSection('.color-collapse');
    }
    $('.colors-container').slideDown(300);
    setTimeout(() => {
      if (!null_product_active) {
        $('.active-product').slideDown(300);
      }
    }, 200);
  });

  $('.colors').on('click', '.color', function () {
    $('.color').removeClass('active');
    $('.category-title.color-section').addClass('closed');
    $(this).addClass('active');
    activeColorID = $(this).data('id');
    if ($(this).hasClass('null-product')) {
      hideActiveProduct();
      helpers.removeMakeup(activeCategoryName);
      helpers.removeProduct();
      return;
    }
    const productName = $(this).data('product-name'),
      productCategory = $(this).data('category'),
      productColor = $(this).data('color-name'),
      productCode = $(this).data('product-code'),
      productImage = $(this).data('product-image'),
      hdriUrlForGlass = $(this).data('hdri');

    const productVariantId = helpers.getDeepLinkValue(activeColorID, productList);
    window.parent.postMessage(
      {
        hitType: 'event',
        event: 'color_chosen',
        productCategory: productCategory,
        productGroup: productName,
        productColor: productColor,
        productId: productVariantId,
      },
      '*',
    );

    helpers.sendEventToMobileApps({
      key: helpers.TemplateEvents.PRODUCT_VARIANT_SELECTED,
      value: `${productVariantId}_${productColor}`,
    });
    helpers.applySelectedProduct({
      productCategory,
      productCode,
      productColor,
      productName,
      productId: activeColorID,
      hdriUrlForGlass,
    });
    helpers.toggleProductButtons({
      activeColorID,
      goProductSelector: '.go-product-btn',
      addCartSelector: '.add-cart-btn',
      productQRSelector: '.all-product-qr',
    });

    $('.active-product-name').html(productColor);
    if (hasSeriesOrProductQr && hasQr) {
      $('.active-product-name').html(`${productName} - ${productColor}`);
    }
    helpers.hidePaletteProductName(productColor, '.active-product-name');
    $('.active-product').removeClass('passive');

    $('.active-product-image').attr('src', productImage);
  });

  $('.go-product-btn').on('click', function () {
    helpers.goProductAction({ activeColorID, products: productList });
  });

  $('.add-cart-btn').click(function () {
    helpers.addCartAction({ activeColorID, products: productList });
    const matchedProduct = productList.find((product) => product.id == activeColorID);
    if (hasProductQrLinkButton) allProductBarcode.push(matchedProduct.barcode);
  });

  $('.all-product-qr').click(function () {
    helpers.createProductQR(allProductBarcode);
  });

  $('.close-button').click(function () {
    $('.qr-popup').hide();
    allProductBarcode = [];
  });

  $(window).scroll(function () {
    var sticky = $('.plugin'),
      scroll = $(window).scrollTop();
    if (scroll >= 100) sticky.addClass('fixed');
    else sticky.removeClass('fixed');
  });

  if (typeof window !== 'undefined') {
    sdkConnector({ actions: publicActions, events: publicEvents });
  }
});

const publicActions = {
  customize: (customization = {}) => {
    if (typeof customization !== 'object') throw new Error('customizaion must be an object');
    Object.entries(customization).map(([key, value]) => {
      if (typeof TemplateFields[key] === 'undefined') {
        throw new Error(`${key} is not customizable`);
      }
      updateTemplateFieldFromExternal(value, key);
    });
  },
};

export const publicEvents = {
  onError: () => undefined,
  onAddToCart: () => undefined,
  onGoToProduct: () => undefined,
};

// Manage plugin and parent message communication
window.addEventListener('message', (event) => {
  const PluginEvents = helpers.PluginEvents;
  const LegacyPluginEvents = helpers.LegacyPluginEvents;
  const UserInteraction = helpers.UserInteraction;

  if (!event.data || !Object.values(PluginEvents).includes(event.data.event_id)) return;

  const eventId = event.data.event_id;
  const data = event.data.data;

  switch (eventId) {
    case LegacyPluginEvents.INITIALIZED:
    case PluginEvents.INITIALIZED: {
      helpers.sendEventToMobileApps({ key: eventId, value: eventId });
      break;
    }
    case LegacyPluginEvents.KVKK_CHECKED:
    case PluginEvents.KVKK_CHECKED: {
      const { target, toggleKvkkCheckbox } = data;
      // Iframes send each other's selector as target.
      if (document.getElementById(target)) {
        document.getElementById(target).contentWindow.window.postMessage(
          JSON.stringify({
            toggleKvkkCheckbox,
          }),
          '*',
        );
      }
      break;
    }
    case LegacyPluginEvents.TAKE_PHOTO:
    case LegacyPluginEvents.CHOOSE_MODEL:
    case PluginEvents.TAKE_PHOTO:
    case PluginEvents.CHOOSE_MODEL: {
      helpers.sendEventToMobileApps({ key: eventId, value: eventId });
      const selectedEvent =
        eventId == PluginEvents.TAKE_PHOTO
          ? UserInteraction.TAKE_PHOTO
          : UserInteraction.CHOOSE_MODEL;
      window.parent.postMessage(
        {
          hitType: 'event',
          // This event is typed wrong, should be deleted if no partner uses it.
          event: UserInteraction.SELECT_SPECIFIC_MODEL,
          selected_method: selectedEvent,
        },
        '*',
      );
      break;
    }
    case LegacyPluginEvents.FACE_NOT_FOUND:
    case PluginEvents.FACE_NOT_FOUND: {
      helpers.sendEventToMobileApps({ key: eventId, value: eventId });
      break;
    }
    case PluginEvents.SELECT_SPECIFIC_MODEL: {
      const modelUrl = data.url;
      if (!modelUrl) console.error('Model url is not provided');
      helpers.sendEventToMobileApps({ key: eventId, value: modelUrl });
      break;
    }
    default:
      break;
  }
});
